/**
 * The one pointer on the site that the egg hunt exists at all: a note in the
 * browser console. It stays out of the layout and the corporate design, is
 * exactly the kind of place curious people look, and doubles as the progress
 * counter while hunting ("3 of 6 found").
 *
 * The actual riddles are dropped in the community, not here.
 *
 * Console output stays English on purpose - it is dev-facing, and translating
 * it would put nine locales through the pot file for something no visitor
 * reads in their own language.
 */

import { progress } from './engine'

// escaped backslashes: in a template literal `\_` would silently swallow the
// backslash and mangle the sheep
const sheep = `
     ___
  __(o o)
 (       )
  |_| |_|
`

const heading = 'font: bold 13px sans-serif; color: #d99b1c'
const body = 'font: 12px sans-serif; color: #8e8e93'

let printed = false

/** Print the hint once per page load. */
export function printEasterEggHint() {
  if (printed) return
  printed = true

  const { found, total, complete } = progress()

  // only offered once there is progress worth throwing away
  const resetLine =
    found.length > 0 ? '\nStart over: icfEasterEggs.reset()' : ''

  if (complete) {
    console.log(
      `%c${sheep}\n%cICF Easter Egg Hunt - all %c${total}%c found. The header logo is yours now.${resetLine}`,
      heading,
      body,
      heading,
      body
    )
    return
  }

  console.log(
    `%c${sheep}\n%cICF Easter Egg Hunt: %c${found.length} of ${total}%c found.\nSomething is hidden in this site. Search, click, get lost - hints drop in our community.${resetLine}`,
    heading,
    body,
    heading,
    body
  )
}
